<!--  -->
<template>
  <div class="progress-style" v-if="changeProgressNumEnd">
    <div class="center-flex">
        <Progress :percent="percent" :stroke-width="20" class="test-vue"   ref="progressChange" :stroke-color="strokeColor" hide-info></Progress>
        <div style="margin-left:10px;"> {{this.changeProgressNumStart + '/' + this.changeProgressNumEnd}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  props: ['strokeColor', 'sum', 'finishCount'],
  data () {
    return {
      // 横向进度条
      // percent: 40,
      changeProgressNumStart: this.finishCount ? Number(this.finishCount) : 0,
      changeProgressNumEnd: this.sum ? Number(this.sum) : 0
    }
  },
  computed: {
    // progressNum: function () {
    //   return this.changeProgressNumStart + '/' + this.changeProgressNumEnd
    // },
    percent: function () {
      let num = (this.changeProgressNumStart / this.changeProgressNumEnd) * 100 > 100 ? 100 : (this.changeProgressNumStart / this.changeProgressNumEnd) * 100
      return num
    }
  },
  watch: {
    finishCount (val) {
      this.changeProgressNumStart = val
      // this.init()
    },
    sum (val) {
      this.changeProgressNumEnd = val
      // this.init()
    }
  },
  mounted () {
    // this.init()
  },
  methods: {
    // init () {
    //   this.$refs.progressChange.$el.children[0].children[0].children[0].setAttribute('data-num', this.progressNum)
    // }
  }
}
</script>
<style lang='less'>
// 横向进度条
// .progress-style{
//   .ivu-progress-bg::after {
//     display: block;
//     content:attr(data-num);
//     position:absolute;
//     right:3%;
//     top:50%;
//     transform: translateY(-50%);
//     color:#ffffff;
//   }
// }
.center-flex{
  display: flex;
  align-items: center;
}
</style>
